import { useDispatch } from 'react-redux';
import { setAudioDevices, setAudioOutputs, setVideoDevices } from '../../stores/actions/video';

function filterVideoDevices(device: MediaDeviceInfo): boolean {
	return device.kind === 'videoinput' && !!device.deviceId;
}

function filterAudioDevices(device: MediaDeviceInfo): boolean {
	return device.kind === 'audioinput' && !!device.deviceId;
}

function filterAudioOutput(device: MediaDeviceInfo): boolean {
	return device.kind === 'audiooutput' && !!device.deviceId;
}

export default function useUpdateDevices() {
    const dispatch = useDispatch();

    async function updateMediaDevices(
        currCams?: MediaDeviceInfo[],
        currMics?: MediaDeviceInfo[],
        currSpeakers?: MediaDeviceInfo[]
    ) {
        const devices = await navigator.mediaDevices.enumerateDevices();
		const cameras = devices.filter(filterVideoDevices);
		const microphones = devices.filter(filterAudioDevices);
		const speakers = devices.filter(filterAudioOutput);

		dispatch(setVideoDevices(cameras));
		dispatch(setAudioDevices(microphones));
		dispatch(setAudioOutputs(speakers));

		return { cameras, microphones, speakers };
    }

    return {
        updateMediaDevices
    };
}